<script>
    export default {
        name: 'NormalButton',
        props: {
            // 类似
            theme: {
                type: String,
                default: 'default',
                required: false
            },
            // 是否禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            // 是否可以选择多个文件
            multiple: {
                default: false,
                required: false
            },
        },
        computed: {
            compClass () {
                return {
                    [`normal-file-btn__${this.theme}`]: this.theme,
                    'normal-file-btn__disabled': this.disabled
                };
            }
        },
        methods: {
            change (e) {
                const fileDom = e.target;
                this.$emit('change', fileDom.files);
                if (!this.$util.isIE()) {
                    setTimeout(() => {
                        fileDom.value = '';
                    });
                }
            }
        }

    };
</script>
<template>
    <div class="normal-file-btn"
         :class="compClass"
    >
        <slot></slot>
        <input class="file-input"
               :disabled="disabled"
               type="file"
               :multiple="multiple"
               @change="change($event)">
    </div>
</template>
<style scoped lang="less">
    @import "../../assets/less/widgets-var";

    .normal-file-btn {
        font-family: cmsicon;
        position: relative;
        display: block;
        margin-left: auto;
        margin-right: auto;
        .px2rem(padding-left, 28);
        .px2rem(padding-right, 28);
        .px2rem(font-size, 36);
        .px2rem(height, 88);
        .px2rem(line-height, 88);
        box-sizing: border-box;
        color: #FFFFFF;
        border-radius: 5px;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        overflow: hidden;
        .transition-on;

        > .file-input {
            cursor: pointer;
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            bottom: 0;
            right: 0;
        }

        &.normal-file-btn__default {
            border: 1px dashed @otherGreyBgClr;
            color: @otherTextClr;


            &.normal-file-btn__disabled {
                border: none;
                background: @otherDisabledBgClr;
                color: @otherBtnBorderNoteClr;
            }
        }

        &.normal-file-btn__primary {
            background: 1px solid @primaryBg;
            color: @whiteBg;

            &:not(.normal-file-btn__disabled):active {
                background: 1px solid @primaryActiveBg;
                color: @whiteBg;
            }

            &.normal-file-btn__disabled {
                background: 1px solid @primaryDisabledBg;
                color: @whiteBg;
            }
        }

        &.normal-file-btn__warn {
            background: 1px solid @warnBg;
            color: @whiteBg;

            &:not(.normal-file-btn__disabled):active {
                background: 1px solid @warnBg;
                color: @whiteBg;
            }

            &.normal-file-btn__disabled {
                background: 1px solid @warnDisabledBg;
                color: @whiteBg;
            }
        }

        &.normal-file-btn__danger {
            background: 1px solid @dangerBg;
            color: @whiteBg;

            &:not(.normal-file-btn__disabled):active {
                background: 1px solid @dangerActiveBg;
                color: @whiteBg;
            }

            &.normal-file-btn__disabled {
                background: 1px solid @dangerDisabledBg;
                color: @whiteBg;
            }
        }
    }
</style>
